import Sigma from 'sigma';
import FileSaver from 'file-saver';

var DEFAULT_TO_IMAGE_OPTIONS = {
  layers: null,
  width: null,
  height: null,
  fileName: "graph",
  format: "png",
  sigmaSettings: {},
  cameraState: null,
  backgroundColor: "transparent",
  withTempRenderer: null
};

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

/**
 * This function takes a Sigma instance and some options, and returns a HTMLCanvasElement, with all the sigma layers
 * drawn on it. This new canvas can then be used to generate PNG or JPEG images, for instance.
 */
function drawOnCanvas(_x) {
  return _drawOnCanvas.apply(this, arguments);
}
function _drawOnCanvas() {
  _drawOnCanvas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(sigma) {
    var opts,
      _DEFAULT_TO_IMAGE_OPT,
      layers,
      backgroundColor,
      width,
      height,
      cameraState,
      sigmaSettings,
      withTempRenderer,
      dimensions,
      pixelRatio,
      outputWidth,
      outputHeight,
      tmpRoot,
      tempRenderer,
      canvas,
      ctx,
      canvases,
      canvasLayers,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          _DEFAULT_TO_IMAGE_OPT = _objectSpread2(_objectSpread2({}, DEFAULT_TO_IMAGE_OPTIONS), opts), layers = _DEFAULT_TO_IMAGE_OPT.layers, backgroundColor = _DEFAULT_TO_IMAGE_OPT.backgroundColor, width = _DEFAULT_TO_IMAGE_OPT.width, height = _DEFAULT_TO_IMAGE_OPT.height, cameraState = _DEFAULT_TO_IMAGE_OPT.cameraState, sigmaSettings = _DEFAULT_TO_IMAGE_OPT.sigmaSettings, withTempRenderer = _DEFAULT_TO_IMAGE_OPT.withTempRenderer;
          dimensions = sigma.getDimensions();
          pixelRatio = window.devicePixelRatio || 1;
          outputWidth = typeof width !== "number" ? dimensions.width : width;
          outputHeight = typeof height !== "number" ? dimensions.height : height;
          tmpRoot = document.createElement("DIV");
          tmpRoot.style.width = "".concat(outputWidth, "px");
          tmpRoot.style.height = "".concat(outputHeight, "px");
          tmpRoot.style.position = "absolute";
          tmpRoot.style.right = "101%";
          tmpRoot.style.bottom = "101%";
          document.body.appendChild(tmpRoot);

          // Instantiate sigma:
          tempRenderer = new Sigma(sigma.getGraph(), tmpRoot, _objectSpread2(_objectSpread2({}, sigma.getSettings()), sigmaSettings)); // Copy camera and force to render now, to avoid having to wait the schedule /
          // debounce frame:
          tempRenderer.getCamera().setState(cameraState || sigma.getCamera().getState());
          tempRenderer.setCustomBBox(sigma.getCustomBBox());
          tempRenderer.refresh();

          // Create a new canvas, on which the different layers will be drawn:
          canvas = document.createElement("CANVAS");
          canvas.setAttribute("width", outputWidth * pixelRatio + "");
          canvas.setAttribute("height", outputHeight * pixelRatio + "");
          ctx = canvas.getContext("2d"); // Draw the background first:
          ctx.fillStyle = backgroundColor;
          ctx.fillRect(0, 0, outputWidth * pixelRatio, outputHeight * pixelRatio);
          if (!withTempRenderer) {
            _context.next = 26;
            break;
          }
          _context.next = 26;
          return withTempRenderer(tempRenderer);
        case 26:
          // For each layer, draw it on our canvas:
          canvases = tempRenderer.getCanvases();
          canvasLayers = layers ? layers.filter(function (id) {
            return !!canvases[id];
          }) : Object.keys(canvases);
          canvasLayers.forEach(function (id) {
            ctx.drawImage(canvases[id], 0, 0, outputWidth * pixelRatio, outputHeight * pixelRatio, 0, 0, outputWidth * pixelRatio, outputHeight * pixelRatio);
          });

          // Cleanup:
          tempRenderer.kill();
          tmpRoot.remove();
          return _context.abrupt("return", canvas);
        case 32:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _drawOnCanvas.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded = ["format"];

/**
 * This function takes a Sigma instance, draws its layers on a canvas using `drawOnCanvas`, and returns a promise that
 * resolves to a blob of the expected image. Accepted formats are "image/png" and "image/jpeg".
 */
function toBlob(_x) {
  return _toBlob.apply(this, arguments);
}

/**
 * This function takes a Sigma instance, calls `toBlob`, and returns a File instance of the given blob.
 */
function _toBlob() {
  _toBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(sigma) {
    var opts,
      _DEFAULT_TO_IMAGE_OPT,
      format,
      options,
      canvas,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          _DEFAULT_TO_IMAGE_OPT = _objectSpread2(_objectSpread2({}, DEFAULT_TO_IMAGE_OPTIONS), opts), format = _DEFAULT_TO_IMAGE_OPT.format, options = _objectWithoutProperties(_DEFAULT_TO_IMAGE_OPT, _excluded);
          _context.next = 4;
          return drawOnCanvas(sigma, options);
        case 4:
          canvas = _context.sent;
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            canvas.toBlob(function (blob) {
              if (blob) {
                resolve(blob);
              } else {
                reject(new Error("No actual blob was obtained by canvas.toBlob(..., \"image/".concat(format, "\")")));
              }
            }, "image/".concat(format));
          }));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _toBlob.apply(this, arguments);
}
function toFile(_x2) {
  return _toFile.apply(this, arguments);
}
function _toFile() {
  _toFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(sigma) {
    var opts,
      _DEFAULT_TO_IMAGE_OPT2,
      fileName,
      format,
      blob,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          opts = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          _DEFAULT_TO_IMAGE_OPT2 = _objectSpread2(_objectSpread2({}, DEFAULT_TO_IMAGE_OPTIONS), opts), fileName = _DEFAULT_TO_IMAGE_OPT2.fileName, format = _DEFAULT_TO_IMAGE_OPT2.format;
          _context2.next = 4;
          return toBlob(sigma, opts);
        case 4:
          blob = _context2.sent;
          return _context2.abrupt("return", new File([blob], "".concat(fileName, ".").concat(format)));
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _toFile.apply(this, arguments);
}

/**
 * This function takes a Sigma instance, draws its layers on a canvas using `drawOnCanvas`, and then downloads a local
 * image file from the canvas. Accepted formats are "image/png" and "image/jpeg".
 */
function downloadAsImage(_x) {
  return _downloadAsImage.apply(this, arguments);
}

/**
 * This function is just some sugar around `downloadAsImage`, with forced PNG format.
 */
function _downloadAsImage() {
  _downloadAsImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(sigma) {
    var opts,
      _DEFAULT_TO_IMAGE_OPT,
      fileName,
      format,
      blob,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          _DEFAULT_TO_IMAGE_OPT = _objectSpread2(_objectSpread2({}, DEFAULT_TO_IMAGE_OPTIONS), opts), fileName = _DEFAULT_TO_IMAGE_OPT.fileName, format = _DEFAULT_TO_IMAGE_OPT.format;
          _context.next = 4;
          return toBlob(sigma, opts);
        case 4:
          blob = _context.sent;
          FileSaver.saveAs(blob, "".concat(fileName, ".").concat(format));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _downloadAsImage.apply(this, arguments);
}
function downloadAsPNG(sigma) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return downloadAsImage(sigma, _objectSpread2(_objectSpread2({}, opts), {}, {
    format: "png"
  }));
}

/**
 * This function is just some sugar around `downloadAsImage`, with forced JPEG format.
 */
function downloadAsJPEG(sigma) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return downloadAsImage(sigma, _objectSpread2(_objectSpread2({}, opts), {}, {
    format: "jpeg"
  }));
}

export { DEFAULT_TO_IMAGE_OPTIONS, downloadAsImage, downloadAsJPEG, downloadAsPNG, drawOnCanvas, toBlob, toFile };
